module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sessions-awards-ceremony.json
// module id = 420
// module chunks = 197934007155303